import { defineStore } from 'pinia'
import { apiParentIdOf } from '../utils/folderTree'

export const useCommonStore = defineStore('common', {
  state: () => ({
    folderId: '',
    space: '',
    userInfo: {}
  }),
  actions: {
    init() {
      this.userInfo = JSON.parse(sessionStorage.getItem('SCANAT_USER_INFO')) ?? {}
    },
    setFolderId(folderId) {
      this.folderId = apiParentIdOf(folderId) || '0'
    },
    setSpace(space) {
      this.space = space
    }
  }
})
